import React from "react";
import { TimeLeftCell } from "@limitless/portal";
import RenderFieldState from "../render-field-state/RenderFieldState";
import { calculateTimeLeft } from "../../../utils/TimeCalcUtil";
const ExpiryMessageCell = value => {
  return Object.keys(calculateTimeLeft(value)).length > 0 ? /*#__PURE__*/React.createElement(TimeLeftCell, {
    value: value
  }) : /*#__PURE__*/React.createElement(RenderFieldState, {
    state: {
      label: "AVAILABLE",
      value: "AVAILABLE"
    }
  });
};
export default ExpiryMessageCell;